<template>
  <TWModal
    :title="$t('bulkSend.deleteBulkSendModal.title', { name })"
    :loading="loading"
    :show="show"
    @close="$emit('close')"
    :allow-outside-click-to-close="false"
  >
    <template v-slot:content>
      <p>{{ $t('bulkSend.deleteBulkSendModal.text') }}</p>
    </template>

    <template v-slot:controls>
      <BaseButton
        variant="invisible"
        @click.native="$emit('close')"
        data-ec="delete_bulk_send_modal"
        data-et="cancel_button"
      >
        <span>{{ $t('functional.cancel') }}</span>
      </BaseButton>

      <BaseButton
        @click.native="handleDeleteBulkSend"
        data-ec="delete_bulk_send_modal"
        data-et="delete_button"
      >
        <span>{{ $t('functional.delete') }}</span>
      </BaseButton>
    </template>
  </TWModal>
</template>

<script>
  import TWModal from '@/components/tailwind/Modal.vue';
  import BaseButton from '@/components/library/buttons/BaseButton.vue';
  import useRequest from '@/composables/actions/request';

  export default {
    name: 'DeleteDraftBulkSendModal',
    components: {
      TWModal,
      BaseButton,
    },
    setup() {
      const deleteDraftBulkSend = useRequest('bulk-sends', { method: 'DELETE' });

      return { deleteDraftBulkSend };
    },
    data() {
      return {
        loading: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      fingerprint: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
    },
    methods: {
      async handleDeleteBulkSend() {
        this.loading = true;
        await this.deleteDraftBulkSend(this.fingerprint);
        this.$emit('refreshList');
        this.loading = false;
        this.$emit('close');
      },
    },
  };
</script>
